<template>
  <section class="gosuslugi-banner">
    <div class="gosuslugi-banner__container">
      <div id="js-show-iframe-wrapper">
        <div class="pos-banner-fluid bf-17">
          <div class="bf-17__decor">
            <div class="bf-17__logo-wrap">
              <img
                class="bf-17__logo"
                src="https://pos.gosuslugi.ru/bin/banner-fluid/gosuslugi-logo-blue.svg"
                alt="Госуслуги"
              >
              <div class="bf-17__slogan">Решаем вместе</div>
            </div>
          </div>
          <div class="bf-17__content">
            <div class="bf-17__text">
              Недовольны работой больницы?
            </div>
            <div class="bf-17__bottom-wrap">
              <div class="bf-17__btn-wrap">
                <!-- pos-banner-btn_2 не удалять; другие классы не добавлять -->
                <button class="pos-banner-btn_2" type="button">
                  Написать о проблеме
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const POS_SCRIPT_SRC = 'https://pos.gosuslugi.ru/bin/script.min.js';
const POS_FORM_URL = 'https://pos.gosuslugi.ru/form';
const POS_WIDGET_ID = 225438;
const POS_PREFIX_17 = '--pos-banner-fluid-17__';

const posOptionsInitialBanner17 = {
  background: '#ffffff',
  'grid-template-columns': '100%',
  'grid-template-rows': '188px auto',
  'max-width': '100%',
  'text-font-size': '24px',
  'text-margin': '0 0 24px 0',
  'button-wrap-max-width': '100%',
  'bg-url': "url('https://pos.gosuslugi.ru/bin/banner-fluid/6/banner-fluid-bg-6.svg')",
  'bg-url-position': 'center bottom',
  'bg-size': 'contain',
  'content-padding': '24px',
  'content-grid-row': '0',
  'logo-width': '65px',
  'logo-wrap-top': '16px',
  'logo-wrap-right': '13px',
  'slogan-font-size': '12px',
};

function setStyles(styles, el, prefix = POS_PREFIX_17) {
  Object.keys(styles).forEach((key) => {
    el.style.setProperty(prefix + key, styles[key]);
  });
}

function removeStyles(styles, el, prefix = POS_PREFIX_17) {
  Object.keys(styles).forEach((key) => {
    el.style.removeProperty(prefix + key);
  });
}

function loadPosScript() {
  return new Promise((resolve, reject) => {
    if (typeof window.Widget === 'function') {
      resolve();
      return;
    }

    const existing = document.querySelector(`script[src="${POS_SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', reject);
      return;
    }

    const script = document.createElement('script');
    script.src = POS_SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export default {
  name: 'GosuslugiBanner',
  mounted() {
    this.changePosBannerOnResize = this.changePosBannerOnResize.bind(this);
    this.changePosBannerOnResize();
    window.addEventListener('resize', this.changePosBannerOnResize);

    loadPosScript()
      .then(() => {
        if (typeof window.Widget === 'function') {
          window.Widget(POS_FORM_URL, POS_WIDGET_ID);
        }
      })
      .catch((error) => {
        console.error('Не удалось загрузить виджет Госуслуг', error);
      });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.changePosBannerOnResize);
    removeStyles({ ...posOptionsInitialBanner17 }, document.documentElement);
  },
  methods: {
    changePosBannerOnResize() {
      const root = document.documentElement;
      const options = { ...posOptionsInitialBanner17 };
      const banner = document.getElementById('js-show-iframe-wrapper');
      const width = banner ? banner.offsetWidth : document.body.offsetWidth;

      if (width > 340) {
        options['grid-template-rows'] = '236px auto';
        options['bg-url'] = "url('https://pos.gosuslugi.ru/bin/banner-fluid/6/banner-fluid-bg-6-2.svg')";
        options['button-wrap-max-width'] = '209px';
        options['content-padding'] = '24px 32px';
        options['text-margin'] = '0 0 24px 0';
      }
      if (width > 350) {
        options['bg-url-position'] = 'center bottom calc(100% - 40px)';
      }
      if (width > 415) {
        options['bg-url-position'] = 'center bottom';
      }
      if (width > 568) {
        options['grid-template-columns'] = '1fr 292px';
        options['grid-template-rows'] = '100%';
        options['content-grid-row'] = '1';
        options['content-padding'] = '32px 24px 24px';
        options['bg-url'] = "url('https://pos.gosuslugi.ru/bin/banner-fluid/6/banner-fluid-bg-6.svg')";
      }
      if (width > 783) {
        options['grid-template-columns'] = '1fr 400px';
        options['text-font-size'] = '32px';
        options['content-padding'] = '32px 24px';
        options['bg-url'] = "url('https://pos.gosuslugi.ru/bin/banner-fluid/6/banner-fluid-bg-6-2.svg')";
        options['bg-url-position'] = 'center bottom calc(100% - 25px)';
      }
      if (width > 820) {
        options['grid-template-columns'] = '1fr 420px';
        options['bg-url-position'] = 'center bottom';
      }
      if (width > 1098) {
        options['bg-url'] = "url('https://pos.gosuslugi.ru/bin/banner-fluid/6/banner-fluid-bg-6-3.svg')";
        options['grid-template-columns'] = '1fr 557px';
        options['text-font-size'] = '36px';
        options['content-padding'] = '32px 32px 32px 50px';
        options['logo-width'] = '78px';
        options['logo-wrap-top'] = '20px';
        options['logo-wrap-right'] = '17px';
        options['slogan-font-size'] = '15px';
      }
      if (width > 1422) {
        options['max-width'] = '1422px';
        options['grid-template-columns'] = '1fr 720px';
        options['content-padding'] = '32px 48px 32px 160px';
        options.background = 'linear-gradient(90deg, #ffffff 50%, #f8efec 50%)';
      }

      setStyles(options, root);
    },
  },
};
</script>

<style>
.gosuslugi-banner {
  padding: 24px 0;
}

#js-show-iframe-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 293px;
  max-width: 100%;
  background: linear-gradient(138.4deg, #38bafe 26.49%, #2d73bc 79.45%);
  color: #fff;
  cursor: pointer;
}

#js-show-iframe-wrapper .pos-banner-fluid * {
  box-sizing: border-box;
}

#js-show-iframe-wrapper .pos-banner-fluid .pos-banner-btn_2 {
  display: block;
  width: 240px;
  min-height: 56px;
  font-size: 18px;
  line-height: 24px;
  cursor: pointer;
  background: #0d4cd3;
  color: #fff;
  border: none;
  border-radius: 8px;
  outline: 0;
}

#js-show-iframe-wrapper .pos-banner-fluid .pos-banner-btn_2:hover {
  background: #1d5deb;
}

#js-show-iframe-wrapper .pos-banner-fluid .pos-banner-btn_2:focus {
  background: #2a63ad;
}

#js-show-iframe-wrapper .pos-banner-fluid .pos-banner-btn_2:active {
  background: #2a63ad;
}

@font-face {
  font-family: LatoWebLight;
  src:
    url(https://pos.gosuslugi.ru/bin/fonts/Lato/fonts/Lato-Light.woff2) format("woff2"),
    url(https://pos.gosuslugi.ru/bin/fonts/Lato/fonts/Lato-Light.woff) format("woff"),
    url(https://pos.gosuslugi.ru/bin/fonts/Lato/fonts/Lato-Light.ttf) format("truetype");
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: LatoWeb;
  src:
    url(https://pos.gosuslugi.ru/bin/fonts/Lato/fonts/Lato-Regular.woff2) format("woff2"),
    url(https://pos.gosuslugi.ru/bin/fonts/Lato/fonts/Lato-Regular.woff) format("woff"),
    url(https://pos.gosuslugi.ru/bin/fonts/Lato/fonts/Lato-Regular.ttf) format("truetype");
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: LatoWebBold;
  src:
    url(https://pos.gosuslugi.ru/bin/fonts/Lato/fonts/Lato-Bold.woff2) format("woff2"),
    url(https://pos.gosuslugi.ru/bin/fonts/Lato/fonts/Lato-Bold.woff) format("woff"),
    url(https://pos.gosuslugi.ru/bin/fonts/Lato/fonts/Lato-Bold.ttf) format("truetype");
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: RobotoWebLight;
  src:
    url(https://pos.gosuslugi.ru/bin/fonts/Roboto/Roboto-Light.woff2) format("woff2"),
    url(https://pos.gosuslugi.ru/bin/fonts/Roboto/Roboto-Light.woff) format("woff"),
    url(https://pos.gosuslugi.ru/bin/fonts/Roboto/Roboto-Light.ttf) format("truetype");
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: RobotoWebRegular;
  src:
    url(https://pos.gosuslugi.ru/bin/fonts/Roboto/Roboto-Regular.woff2) format("woff2"),
    url(https://pos.gosuslugi.ru/bin/fonts/Roboto/Roboto-Regular.woff) format("woff"),
    url(https://pos.gosuslugi.ru/bin/fonts/Roboto/Roboto-Regular.ttf) format("truetype");
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: RobotoWebBold;
  src:
    url(https://pos.gosuslugi.ru/bin/fonts/Roboto/Roboto-Bold.woff2) format("woff2"),
    url(https://pos.gosuslugi.ru/bin/fonts/Roboto/Roboto-Bold.woff) format("woff"),
    url(https://pos.gosuslugi.ru/bin/fonts/Roboto/Roboto-Bold.ttf) format("truetype");
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: ScadaWebRegular;
  src:
    url(https://pos.gosuslugi.ru/bin/fonts/Scada/Scada-Regular.woff2) format("woff2"),
    url(https://pos.gosuslugi.ru/bin/fonts/Scada/Scada-Regular.woff) format("woff"),
    url(https://pos.gosuslugi.ru/bin/fonts/Scada/Scada-Regular.ttf) format("truetype");
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: ScadaWebBold;
  src:
    url(https://pos.gosuslugi.ru/bin/fonts/Scada/Scada-Bold.woff2) format("woff2"),
    url(https://pos.gosuslugi.ru/bin/fonts/Scada/Scada-Bold.woff) format("woff"),
    url(https://pos.gosuslugi.ru/bin/fonts/Scada/Scada-Bold.ttf) format("truetype");
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: Geometria;
  src: url(https://pos.gosuslugi.ru/bin/fonts/Geometria/Geometria.eot);
  src:
    url(https://pos.gosuslugi.ru/bin/fonts/Geometria/Geometria.eot?#iefix) format("embedded-opentype"),
    url(https://pos.gosuslugi.ru/bin/fonts/Geometria/Geometria.woff) format("woff"),
    url(https://pos.gosuslugi.ru/bin/fonts/Geometria/Geometria.ttf) format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: Geometria-ExtraBold;
  src: url(https://pos.gosuslugi.ru/bin/fonts/Geometria/Geometria-ExtraBold.eot);
  src:
    url(https://pos.gosuslugi.ru/bin/fonts/Geometria/Geometria-ExtraBold.eot?#iefix) format("embedded-opentype"),
    url(https://pos.gosuslugi.ru/bin/fonts/Geometria/Geometria-ExtraBold.woff) format("woff"),
    url(https://pos.gosuslugi.ru/bin/fonts/Geometria/Geometria-ExtraBold.ttf) format("truetype");
  font-weight: 900;
  font-style: normal;
}

#js-show-iframe-wrapper {
  background: var(--pos-banner-fluid-17__background);
}

#js-show-iframe-wrapper .pos-banner-fluid .pos-banner-btn_2 {
  width: 100%;
  min-height: 52px;
  background: #fff;
  color: #0d4cd3;
  font-size: 16px;
  font-family: LatoWeb, sans-serif;
  font-weight: 400;
  padding: 0;
  line-height: 1.2;
  border: 2px solid #0d4cd3;
}

#js-show-iframe-wrapper .pos-banner-fluid .pos-banner-btn_2:active,
#js-show-iframe-wrapper .pos-banner-fluid .pos-banner-btn_2:focus,
#js-show-iframe-wrapper .pos-banner-fluid .pos-banner-btn_2:hover {
  background: #e4ecfd;
}

#js-show-iframe-wrapper .bf-17 {
  position: relative;
  display: grid;
  grid-template-columns: var(--pos-banner-fluid-17__grid-template-columns);
  grid-template-rows: var(--pos-banner-fluid-17__grid-template-rows);
  width: 100%;
  max-width: var(--pos-banner-fluid-17__max-width);
  box-sizing: border-box;
  grid-auto-flow: row dense;
}

#js-show-iframe-wrapper .bf-17__decor {
  background: var(--pos-banner-fluid-17__bg-url) var(--pos-banner-fluid-17__bg-url-position) no-repeat;
  background-size: var(--pos-banner-fluid-17__bg-size);
  background-color: #f8efec;
  position: relative;
}

#js-show-iframe-wrapper .bf-17__content {
  display: flex;
  flex-direction: column;
  padding: var(--pos-banner-fluid-17__content-padding);
  grid-row: var(--pos-banner-fluid-17__content-grid-row);
  justify-content: center;
}

#js-show-iframe-wrapper .bf-17__text {
  margin: var(--pos-banner-fluid-17__text-margin);
  font-size: var(--pos-banner-fluid-17__text-font-size);
  line-height: 1.2;
  font-family: LatoWeb, sans-serif;
  font-weight: 700;
  color: #0b1f33;
}

#js-show-iframe-wrapper .bf-17__bottom-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
}

#js-show-iframe-wrapper .bf-17__logo-wrap {
  position: absolute;
  top: var(--pos-banner-fluid-17__logo-wrap-top);
  right: var(--pos-banner-fluid-17__logo-wrap-right);
}

#js-show-iframe-wrapper .bf-17__logo {
  width: var(--pos-banner-fluid-17__logo-width);
  margin-left: 1px;
}

#js-show-iframe-wrapper .bf-17__slogan {
  font-family: LatoWeb, sans-serif;
  font-weight: 700;
  font-size: var(--pos-banner-fluid-17__slogan-font-size);
  line-height: 1.2;
  color: #005ca9;
}

#js-show-iframe-wrapper .bf-17__btn-wrap {
  width: 100%;
  max-width: var(--pos-banner-fluid-17__button-wrap-max-width);
}
</style>
